import { render, staticRenderFns } from "./ColoriNave.vue?vue&type=template&id=602527d4&"
import script from "./ColoriNave.vue?vue&type=script&lang=js&"
export * from "./ColoriNave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports